import { Container, Text } from "basis";
import { ImportantInformationList } from "./ImportantInformationList";

export const ImportantInformation = () => (
  <Container bg="secondary.lightBlue.t25" padding="4">
    <Container bg="white" padding="6">
      <Text textStyle="heading5" margin="0 0 4 0">
        Important information
      </Text>
      <ImportantInformationList />
    </Container>
  </Container>
);
